import React, { useState } from "react";
import logo from "../../assets/images/logo.png";
import "./Header.css";

const Header = () => {
  const [activeLang, setActiveLang] = useState("ru");

  return (
    <>
      <div className="header-notification">
        <div className="header-notification__content">
          Арсений Ступников
          <span>
            <a
              href="https://senyer7.ru"
              target="_blank"
              rel="noopener noreferrer"
            >
              (@senyer7)
            </a>
          </span>{" "}
          переписал учебный сайт Я.Практикума на React
        </div>
      </div>

      <header className="header">
        <img alt="логотип сайта" src={logo} className="header__logo" />
        <div className="header__language">
          <button
            className={`header__lang ${
              activeLang === "ru" ? "header__lang--active" : ""
            }`}
            onClick={() => setActiveLang("ru")}
          >
            ru
          </button>
          <button
            className={`header__lang ${
              activeLang === "en" ? "header__lang--active" : ""
            }`}
            onClick={() => setActiveLang("en")}
          >
            en
          </button>
        </div>
      </header>
    </>
  );
};

export default Header;
